// The study surfaces when the app runs on the API. The Bible map counts the chapters in the plan days
// the reader has marked read (the API's journeys): the iOS reader's own record of chapters read
// isn't synced to the API yet. Reflections are synced notes (studyQueries.ts); the browser-only store
// here is used only outside the signed-in shell.
import { scriptureOf, type PlanSource } from "./plans";
import { localReflections, type StudySource } from "./study";

export function createApiStudy(plans: PlanSource): StudySource {
  return {
    async chaptersRead() {
      const list = await plans.journeys();
      const full = await Promise.all(list.filter((j) => j.me.read.length > 0).map((j) => (j.plan.schedule ? j : plans.journey(j.id))));
      const out: Record<string, Set<number>> = {};
      for (const j of full) {
        if (!j?.plan.schedule) continue;
        for (const day of j.me.read) {
          for (const r of scriptureOf(j.plan.schedule[day - 1])) {
            const set = (out[r.book] ??= new Set());
            for (let c = r.chStart; c <= r.chEnd; c++) set.add(c);
          }
        }
      }
      return Object.fromEntries(Object.entries(out).map(([b, s]) => [b, [...s].sort((x, y) => x - y)]));
    },
    ...localReflections(),
  };
}
